<template>
  <div :class="['modal-wrapper', { open: isModalOpen }]">
    <div class="modal-content" v-if="isModalOpen">
      <button class="close-button">
        <Icon
          class="close-icon"
          color="black"
          :width="16"
          :height="16"
          art="light"
          name="xmark"
          @click.stop="close"
        />
      </button>
      <SanitasSurvey
        v-if="touchPoint"
        :language="language"
        :touch-point="touchPoint"
        :partner-number="partnerNumber"
        :survey-name="surveyName"
        @survey-initialised="startSurvey"
      >
        <Survey v-if="hasSurveyStarted" @close="close" />
      </SanitasSurvey>
    </div>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import SanitasSurvey from 'sanitas-survey-vue2/src/components/common/SanitasSurvey'
import Survey from 'sanitas-survey-vue2/src/components/common/Survey'
import store from '@/store'
import Icon from '@/components/Icon'

export default {
  name: 'SurveyModal',

  components: {
    SanitasSurvey,
    Survey,
    Icon
  },

  setup(_, { emit }) {
    const surveyName = process.env.VUE_APP_TNPS_SURVEY_NAME
    const isModalOpen = ref(true)
    const language = computed(() => store.state.uistate.lang)
    const hasSurveyStarted = computed(() => store.state.survey.started)
    const partnerNumber = computed(() =>
      btoa(store.state.conversation?.user?.customerId)
    )
    const touchPoint = computed(() => {
      const convStore = store.state.conversation
      const conv = convStore.conversation
      const isWebView = store.getters['uistate/webView']
      const isAiaiBotOnly = Boolean(conv?.conversationType === 'AIAIBOT')
      const isChatOnly = Boolean(
        !store.state.uistate.aiaiBotDisclaimerAccepted &&
        conv?.conversationType === 'CHAT'
      )

      const convType = isAiaiBotOnly ? 'AIAIBOT' : isChatOnly ? 'CHAT' : 'MIXED'
      const convChannel = isWebView ? 'KUPOAPP' : 'KUPOWEB'

      console.log(`VUE_APP_TNPS_${convType}_${convChannel}`)

      return process.env[`VUE_APP_TNPS_${convType}_${convChannel}`]
    })

    const startSurvey = () => {
      store.dispatch('survey/startSurvey')
    }

    const close = () => {
      emit('close')
    }

    return {
      isModalOpen,
      language,
      partnerNumber,
      touchPoint,
      hasSurveyStarted,
      surveyName,
      startSurvey,
      close,
    }
  },
}
</script>

<style scoped lang="postcss">
.modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 25, 25, 0.5);
  opacity: 0;
  pointer-events: none;
  z-index: 1000;
  transition: opacity 0.1s linear;

  &.open {
    opacity: 1;
    pointer-events: all;
  }
}

.modal-content {
  position: relative;
  width: 930px;
  max-width: 90%;
  max-height: 80vh;
  padding: 20px;
  background: white;
  pointer-events: all;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background: transparent;
  cursor: pointer;
}
</style>
